/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MachineDocumentCreateModel,
    MachineDocumentCreateModelFromJSON,
    MachineDocumentCreateModelFromJSONTyped,
    MachineDocumentCreateModelToJSON,
} from './MachineDocumentCreateModel';
import {
    MachineRentalTypeCreateModel,
    MachineRentalTypeCreateModelFromJSON,
    MachineRentalTypeCreateModelFromJSONTyped,
    MachineRentalTypeCreateModelToJSON,
} from './MachineRentalTypeCreateModel';

/**
 * 
 * @export
 * @interface MachineEditModel
 */
export interface MachineEditModel {
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    lessorCompanyId?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    subCategoryId?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    brandId?: number;
    /**
     * 
     * @type {string}
     * @memberof MachineEditModel
     */
    brandOther?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineEditModel
     */
    attachmentOther?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineEditModel
     */
    modelName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    productionYear?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    operationMileage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    operationHour?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MachineEditModel
     */
    drivingEquipment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    enginePower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    operatingWeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    tankCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    fuelTypeId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    elevatorTypeId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    operatingHeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    operatingArea?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    operatingLength?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    operationWidth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    operatingCapacity?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MachineEditModel
     */
    usageFields?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineEditModel
     */
    hasCabin?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MachineEditModel
     */
    engineBrand?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineEditModel
     */
    hasPlatform?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineEditModel
     */
    hasTowerElevationSystem?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    lightningCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    carryingCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    width?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    volume?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    height?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    floorCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    liftingHeight?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MachineEditModel
     */
    notes?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineEditModel
     */
    saleNotes?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineEditModel
     */
    hasOperator?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    operatorExperienceYear?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineEditModel
     */
    shipingIncluded?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineEditModel
     */
    operatorCostIncluded?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineEditModel
     */
    operatorInsuranceIncluded?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineEditModel
     */
    fuelIncluded?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    bladeWidth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    frequency?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    minPower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    maxPower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    maxLoadCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    nominalCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    waterTankCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    maxFeedingSize?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    workingSpeed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    cleaningCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    garbageCollectionBin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    breakingInfo?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    bomLength?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    maxHeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    maxDepth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    maxWidth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    compressionWidth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    platformLength?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    platformWidth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    concretePumpingCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    maxPressure?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    freeAirOutput?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    spraySpeed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    tankVolume?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    loadCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    cameraResolutionId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    flightTime?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    flightDistance?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    workingRadius?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineEditModel
     */
    isMachineForSale?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    machineId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    machineSalePrice?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    machineSalePriceCurrencyId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    machineLocationCityId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MachineEditModel
     */
    rentalAdTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineEditModel
     */
    saleAdTitle?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MachineEditModel
     */
    serviceRegions?: Array<number> | null;
    /**
     * 
     * @type {Array<MachineDocumentCreateModel>}
     * @memberof MachineEditModel
     */
    documents?: Array<MachineDocumentCreateModel> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MachineEditModel
     */
    attachments?: Array<number> | null;
    /**
     * 
     * @type {Array<MachineRentalTypeCreateModel>}
     * @memberof MachineEditModel
     */
    rentalTypes?: Array<MachineRentalTypeCreateModel> | null;
    /**
     * 
     * @type {number}
     * @memberof MachineEditModel
     */
    id?: number;
}

export function MachineEditModelFromJSON(json: any): MachineEditModel {
    return MachineEditModelFromJSONTyped(json, false);
}

export function MachineEditModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineEditModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lessorCompanyId': !exists(json, 'lessorCompanyId') ? undefined : json['lessorCompanyId'],
        'subCategoryId': !exists(json, 'subCategoryId') ? undefined : json['subCategoryId'],
        'brandId': !exists(json, 'brandId') ? undefined : json['brandId'],
        'brandOther': !exists(json, 'brandOther') ? undefined : json['brandOther'],
        'attachmentOther': !exists(json, 'attachmentOther') ? undefined : json['attachmentOther'],
        'modelName': !exists(json, 'modelName') ? undefined : json['modelName'],
        'productionYear': !exists(json, 'productionYear') ? undefined : json['productionYear'],
        'operationMileage': !exists(json, 'operationMileage') ? undefined : json['operationMileage'],
        'operationHour': !exists(json, 'operationHour') ? undefined : json['operationHour'],
        'drivingEquipment': !exists(json, 'drivingEquipment') ? undefined : json['drivingEquipment'],
        'enginePower': !exists(json, 'enginePower') ? undefined : json['enginePower'],
        'operatingWeight': !exists(json, 'operatingWeight') ? undefined : json['operatingWeight'],
        'tankCapacity': !exists(json, 'tankCapacity') ? undefined : json['tankCapacity'],
        'fuelTypeId': !exists(json, 'fuelTypeId') ? undefined : json['fuelTypeId'],
        'elevatorTypeId': !exists(json, 'elevatorTypeId') ? undefined : json['elevatorTypeId'],
        'operatingHeight': !exists(json, 'operatingHeight') ? undefined : json['operatingHeight'],
        'operatingArea': !exists(json, 'operatingArea') ? undefined : json['operatingArea'],
        'operatingLength': !exists(json, 'operatingLength') ? undefined : json['operatingLength'],
        'operationWidth': !exists(json, 'operationWidth') ? undefined : json['operationWidth'],
        'operatingCapacity': !exists(json, 'operatingCapacity') ? undefined : json['operatingCapacity'],
        'usageFields': !exists(json, 'usageFields') ? undefined : json['usageFields'],
        'hasCabin': !exists(json, 'hasCabin') ? undefined : json['hasCabin'],
        'engineBrand': !exists(json, 'engineBrand') ? undefined : json['engineBrand'],
        'hasPlatform': !exists(json, 'hasPlatform') ? undefined : json['hasPlatform'],
        'hasTowerElevationSystem': !exists(json, 'hasTowerElevationSystem') ? undefined : json['hasTowerElevationSystem'],
        'lightningCapacity': !exists(json, 'lightningCapacity') ? undefined : json['lightningCapacity'],
        'carryingCapacity': !exists(json, 'carryingCapacity') ? undefined : json['carryingCapacity'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'volume': !exists(json, 'volume') ? undefined : json['volume'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'floorCount': !exists(json, 'floorCount') ? undefined : json['floorCount'],
        'liftingHeight': !exists(json, 'liftingHeight') ? undefined : json['liftingHeight'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'saleNotes': !exists(json, 'saleNotes') ? undefined : json['saleNotes'],
        'hasOperator': !exists(json, 'hasOperator') ? undefined : json['hasOperator'],
        'operatorExperienceYear': !exists(json, 'operatorExperienceYear') ? undefined : json['operatorExperienceYear'],
        'shipingIncluded': !exists(json, 'shipingIncluded') ? undefined : json['shipingIncluded'],
        'operatorCostIncluded': !exists(json, 'operatorCostIncluded') ? undefined : json['operatorCostIncluded'],
        'operatorInsuranceIncluded': !exists(json, 'operatorInsuranceIncluded') ? undefined : json['operatorInsuranceIncluded'],
        'fuelIncluded': !exists(json, 'fuelIncluded') ? undefined : json['fuelIncluded'],
        'bladeWidth': !exists(json, 'bladeWidth') ? undefined : json['bladeWidth'],
        'frequency': !exists(json, 'frequency') ? undefined : json['frequency'],
        'minPower': !exists(json, 'minPower') ? undefined : json['minPower'],
        'maxPower': !exists(json, 'maxPower') ? undefined : json['maxPower'],
        'maxLoadCapacity': !exists(json, 'maxLoadCapacity') ? undefined : json['maxLoadCapacity'],
        'nominalCapacity': !exists(json, 'nominalCapacity') ? undefined : json['nominalCapacity'],
        'waterTankCapacity': !exists(json, 'waterTankCapacity') ? undefined : json['waterTankCapacity'],
        'maxFeedingSize': !exists(json, 'maxFeedingSize') ? undefined : json['maxFeedingSize'],
        'workingSpeed': !exists(json, 'workingSpeed') ? undefined : json['workingSpeed'],
        'cleaningCapacity': !exists(json, 'cleaningCapacity') ? undefined : json['cleaningCapacity'],
        'garbageCollectionBin': !exists(json, 'garbageCollectionBin') ? undefined : json['garbageCollectionBin'],
        'breakingInfo': !exists(json, 'breakingInfo') ? undefined : json['breakingInfo'],
        'bomLength': !exists(json, 'bomLength') ? undefined : json['bomLength'],
        'maxHeight': !exists(json, 'maxHeight') ? undefined : json['maxHeight'],
        'maxDepth': !exists(json, 'maxDepth') ? undefined : json['maxDepth'],
        'maxWidth': !exists(json, 'maxWidth') ? undefined : json['maxWidth'],
        'compressionWidth': !exists(json, 'compressionWidth') ? undefined : json['compressionWidth'],
        'platformLength': !exists(json, 'platformLength') ? undefined : json['platformLength'],
        'platformWidth': !exists(json, 'platformWidth') ? undefined : json['platformWidth'],
        'concretePumpingCapacity': !exists(json, 'concretePumpingCapacity') ? undefined : json['concretePumpingCapacity'],
        'maxPressure': !exists(json, 'maxPressure') ? undefined : json['maxPressure'],
        'freeAirOutput': !exists(json, 'freeAirOutput') ? undefined : json['freeAirOutput'],
        'spraySpeed': !exists(json, 'spraySpeed') ? undefined : json['spraySpeed'],
        'tankVolume': !exists(json, 'tankVolume') ? undefined : json['tankVolume'],
        'loadCapacity': !exists(json, 'loadCapacity') ? undefined : json['loadCapacity'],
        'cameraResolutionId': !exists(json, 'cameraResolutionId') ? undefined : json['cameraResolutionId'],
        'flightTime': !exists(json, 'flightTime') ? undefined : json['flightTime'],
        'flightDistance': !exists(json, 'flightDistance') ? undefined : json['flightDistance'],
        'workingRadius': !exists(json, 'workingRadius') ? undefined : json['workingRadius'],
        'isMachineForSale': !exists(json, 'isMachineForSale') ? undefined : json['isMachineForSale'],
        'machineId': !exists(json, 'machineId') ? undefined : json['machineId'],
        'machineSalePrice': !exists(json, 'machineSalePrice') ? undefined : json['machineSalePrice'],
        'machineSalePriceCurrencyId': !exists(json, 'machineSalePriceCurrencyId') ? undefined : json['machineSalePriceCurrencyId'],
        'machineLocationCityId': !exists(json, 'machineLocationCityId') ? undefined : json['machineLocationCityId'],
        'rentalAdTitle': !exists(json, 'rentalAdTitle') ? undefined : json['rentalAdTitle'],
        'saleAdTitle': !exists(json, 'saleAdTitle') ? undefined : json['saleAdTitle'],
        'serviceRegions': !exists(json, 'serviceRegions') ? undefined : json['serviceRegions'],
        'documents': !exists(json, 'documents') ? undefined : (json['documents'] === null ? null : (json['documents'] as Array<any>).map(MachineDocumentCreateModelFromJSON)),
        'attachments': !exists(json, 'attachments') ? undefined : json['attachments'],
        'rentalTypes': !exists(json, 'rentalTypes') ? undefined : (json['rentalTypes'] === null ? null : (json['rentalTypes'] as Array<any>).map(MachineRentalTypeCreateModelFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function MachineEditModelToJSON(value?: MachineEditModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lessorCompanyId': value.lessorCompanyId,
        'subCategoryId': value.subCategoryId,
        'brandId': value.brandId,
        'brandOther': value.brandOther,
        'attachmentOther': value.attachmentOther,
        'modelName': value.modelName,
        'productionYear': value.productionYear,
        'operationMileage': value.operationMileage,
        'operationHour': value.operationHour,
        'drivingEquipment': value.drivingEquipment,
        'enginePower': value.enginePower,
        'operatingWeight': value.operatingWeight,
        'tankCapacity': value.tankCapacity,
        'fuelTypeId': value.fuelTypeId,
        'elevatorTypeId': value.elevatorTypeId,
        'operatingHeight': value.operatingHeight,
        'operatingArea': value.operatingArea,
        'operatingLength': value.operatingLength,
        'operationWidth': value.operationWidth,
        'operatingCapacity': value.operatingCapacity,
        'usageFields': value.usageFields,
        'hasCabin': value.hasCabin,
        'engineBrand': value.engineBrand,
        'hasPlatform': value.hasPlatform,
        'hasTowerElevationSystem': value.hasTowerElevationSystem,
        'lightningCapacity': value.lightningCapacity,
        'carryingCapacity': value.carryingCapacity,
        'width': value.width,
        'volume': value.volume,
        'height': value.height,
        'floorCount': value.floorCount,
        'liftingHeight': value.liftingHeight,
        'notes': value.notes,
        'saleNotes': value.saleNotes,
        'hasOperator': value.hasOperator,
        'operatorExperienceYear': value.operatorExperienceYear,
        'shipingIncluded': value.shipingIncluded,
        'operatorCostIncluded': value.operatorCostIncluded,
        'operatorInsuranceIncluded': value.operatorInsuranceIncluded,
        'fuelIncluded': value.fuelIncluded,
        'bladeWidth': value.bladeWidth,
        'frequency': value.frequency,
        'minPower': value.minPower,
        'maxPower': value.maxPower,
        'maxLoadCapacity': value.maxLoadCapacity,
        'nominalCapacity': value.nominalCapacity,
        'waterTankCapacity': value.waterTankCapacity,
        'maxFeedingSize': value.maxFeedingSize,
        'workingSpeed': value.workingSpeed,
        'cleaningCapacity': value.cleaningCapacity,
        'garbageCollectionBin': value.garbageCollectionBin,
        'breakingInfo': value.breakingInfo,
        'bomLength': value.bomLength,
        'maxHeight': value.maxHeight,
        'maxDepth': value.maxDepth,
        'maxWidth': value.maxWidth,
        'compressionWidth': value.compressionWidth,
        'platformLength': value.platformLength,
        'platformWidth': value.platformWidth,
        'concretePumpingCapacity': value.concretePumpingCapacity,
        'maxPressure': value.maxPressure,
        'freeAirOutput': value.freeAirOutput,
        'spraySpeed': value.spraySpeed,
        'tankVolume': value.tankVolume,
        'loadCapacity': value.loadCapacity,
        'cameraResolutionId': value.cameraResolutionId,
        'flightTime': value.flightTime,
        'flightDistance': value.flightDistance,
        'workingRadius': value.workingRadius,
        'isMachineForSale': value.isMachineForSale,
        'machineId': value.machineId,
        'machineSalePrice': value.machineSalePrice,
        'machineSalePriceCurrencyId': value.machineSalePriceCurrencyId,
        'machineLocationCityId': value.machineLocationCityId,
        'rentalAdTitle': value.rentalAdTitle,
        'saleAdTitle': value.saleAdTitle,
        'serviceRegions': value.serviceRegions,
        'documents': value.documents === undefined ? undefined : (value.documents === null ? null : (value.documents as Array<any>).map(MachineDocumentCreateModelToJSON)),
        'attachments': value.attachments,
        'rentalTypes': value.rentalTypes === undefined ? undefined : (value.rentalTypes === null ? null : (value.rentalTypes as Array<any>).map(MachineRentalTypeCreateModelToJSON)),
        'id': value.id,
    };
}

